import type { ReactNode } from "react";

export function WelcomeActionRow({ children }: { children: ReactNode }) {
  return (
    <div className="mt-auto flex items-center gap-2.5 border-t border-border pt-2">
      {children}
    </div>
  );
}
